module.exports = "/images/18062375103883be1757f1ec09e56c36.png";